import React, { useRef } from 'react';

import ModalAiArtist from './ModalAiArtist';

import JJUnicornImg from '../../../../../Images/gallery/ai-services/jj-unicorn.png';
import Video1 from '../../../../../Images/gallery/ai-services/jj-unicorn/video-1-h.png';

import {
  JJUnicorn_Title,
  JJUnicorn_Text,
  JJUnicorn_Video1,
} from '../../../../../utils/ES/Modals/aiArtists';

const ModalJJUnicorn = () => {
  return (
    <>
      <ModalAiArtist
        id="artist-jj-unicorn"
        artistImage={JJUnicornImg}
        artistName="JJUnicorn"
        artistTitle={JJUnicorn_Title}
        artisText={JJUnicorn_Text}
        videoRef1={'jj-unicorn-video-1'}
        videoBg1={Video1}
        videoText1={JJUnicorn_Video1}
        videoHorizontal1
      />
    </>
  );
};

export default ModalJJUnicorn;
